import { SnackbarActionHandler } from './snackbar-action-handler';
export class SnackbarConfig {
  actionHandler?: SnackbarActionHandler = null;
  durationInMillis?: number = 3000;
  status?: string = 'success';
}
